import { TestStatus } from '@tests/types';

export const statusOptions = [
  { label: 'Черновик', value: TestStatus.Draft },
  { label: 'Опубликована', value: TestStatus.Published },
  { label: 'Снята с публикации', value: TestStatus.Unpublished },
];
